import type { UrqlClient } from "../../remote/createUrqlClient";
import type {
  capabilitiesQuery,
  featureFlagDynamicQuery,
} from "../../remote/gql/graphql";
import type { IAuthHandler } from "../authHandler";
import type { ClientReturnType } from "../types";
import type { AlaffiaClientModuleArgs } from "./modules";

import { capabilitiesQueryDoc } from "../../remote/queries/capabilities.gql";
import { featureFlagDynamicQueryDoc } from "../../remote/queries/featureFlagDynamic.gql";
import { AuthHandler } from "../authHandler";
import { AlaffiaClientModule } from "./modules";

interface ApiModuleArgs extends AlaffiaClientModuleArgs {
  authHandler?: IAuthHandler;
}

export class ApiModule extends AlaffiaClientModule {
  private authHandler: IAuthHandler;

  constructor(args: ApiModuleArgs) {
    super(args);
    this.authHandler =
      args.authHandler ?? new AuthHandler({ url: args.apiUrl });
  }

  fetchAuthenticatedPost: IAuthHandler["fetchAuthenticatedPost"] = (
    resourcePath,
    bodyObject,
  ) => this.authHandler.fetchAuthenticatedPost(resourcePath, bodyObject);

  getGraphqlClient = (): UrqlClient => {
    return this.getGqlClient();
  };

  featureFlagDynamic = async (input: {
    key: string;
    type: "boolean" | "string" | "number" | "json";
    defaultValue: unknown;
  }): ClientReturnType<featureFlagDynamicQuery["featureFlagDynamic"]> => {
    const result = await this.runGqlQuery(
      featureFlagDynamicQueryDoc,
      {
        key: input.key,
        type: input.type,
        defaultValue: input.defaultValue,
      },
      "featureFlagDynamic",
    );
    return {
      data: result.data?.featureFlagDynamic ?? null,
      error: result.error ?? null,
    };
  };

  capabilities = async (input: {
    filter?: string[];
  }): ClientReturnType<capabilitiesQuery["capabilities"]> => {
    const result = await this.runGqlQuery(
      capabilitiesQueryDoc,
      { filter: input.filter ?? null },
      "capabilities",
      { requestPolicy: "cache-and-network" },
    );
    return {
      data: result.data?.capabilities ?? null,
      error: result.error ?? null,
    };
  };
}
